module.exports = __webpack_public_path__ + "img/idpay.5a7d9510.png";